import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

/* Inline "Learn more" fold — keeps the concept, hides the paragraph until asked. */
export const Learn = ({ label = "Learn more", children, className = "", testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={className}>
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid={testId}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-equal-dark hover:text-ink transition-colors">
        <span className="w-4 h-4 rounded-full border border-current grid place-items-center">
          {open ? <Minus className="w-2.5 h-2.5" /> : <Plus className="w-2.5 h-2.5" />}
        </span>
        {label}
      </button>
      {open && <div className="mt-2 text-sm text-ink-2 leading-relaxed animate-rise-in">{children}</div>}
    </div>
  );
};
